const setDefaultValue = (def, obj) => {
    const type = Object.prototype.toString.call(obj).replace(/^\[\w+\s(\w+)\]$/, '$1');
    if (type === 'Array' && obj.length === 0) {
        obj.push(def);
    }
    return obj;
}

export default setDefaultValue;


// WEBPACK FOOTER //
// ./src/components/shared/setDefaultValue.js